import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Printer, ArrowLeft } from "lucide-react";

export default function PrintDirectory() {
  const [members, setMembers] = useState([]);

  useEffect(() => {
    api.get("/members").then((r) => {
      const sorted = [...r.data].sort((a, b) =>
        `${a.last_name} ${a.first_name}`.localeCompare(`${b.last_name} ${b.first_name}`)
      );
      setMembers(sorted);
    }).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <div className="no-print sticky top-0 bg-[#FBF9F5] border-b border-[#E5E0D8] px-6 py-4 flex items-center justify-between">
        <Link to="/members" className="flex items-center gap-2 text-sm font-medium text-[#2D5A27] hover:underline">
          <ArrowLeft className="h-4 w-4" /> Back to Members
        </Link>
        <Button onClick={() => window.print()} data-testid="print-button" className="bg-[#2D5A27] hover:bg-[#23471F] text-white">
          <Printer className="h-4 w-4 mr-2" /> Print / Save PDF
        </Button>
      </div>

      <div className="max-w-4xl mx-auto px-8 py-10" data-testid="print-directory">
        <div className="text-center mb-8 flex flex-col items-center">
          <img src="/whf-emblem.png" alt="WHF" className="h-16 w-16 object-contain mb-3" />
          <h1 className="font-serif text-3xl font-bold text-[#1C241B]">World Harvest Fellowship — Auckland</h1>
          <p className="text-[#7A8A78] mt-1">Member Directory · {members.length} members</p>
        </div>

        <table className="w-full text-sm border-collapse">
          <thead>
            <tr className="border-b-2 border-[#2D5A27] text-left">
              <th className="py-2 pr-3 font-semibold">Name</th>
              <th className="py-2 pr-3 font-semibold">Family</th>
              <th className="py-2 pr-3 font-semibold">Phone</th>
              <th className="py-2 pr-3 font-semibold">Email</th>
              <th className="py-2 font-semibold">Status</th>
            </tr>
          </thead>
          <tbody>
            {members.map((m) => (
              <tr key={m.id} className="border-b border-[#E5E0D8]">
                <td className="py-2 pr-3 font-medium text-[#1C241B]">{m.first_name} {m.last_name}</td>
                <td className="py-2 pr-3 text-[#526050]">{m.family_name || "—"}</td>
                <td className="py-2 pr-3 text-[#526050]">{m.phone || "—"}</td>
                <td className="py-2 pr-3 text-[#526050]">{m.email || "—"}</td>
                <td className="py-2 capitalize text-[#526050]">{m.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
